export const NETWORK_ERROR_CODE = "ERR_NETWORK"

export const IGNORED_ENTRY_NAMES = new Set([
  "README.md",
  ".clangd",
  ".gitignore",
  ".cph",
  "codes-practice-website",
]);

export const IGNORED_FILE_EXTENSIONS = [".xlsx"];
